module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white-block half left"
  }, [_c('div', {
    staticClass: "patient-info-title"
  }, [(_vm.isCanWrite) ? _c('div', {
    staticClass: "sched_plus"
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "edit"
  }), _vm._v(" "), _c('p', [_vm._v("Аллергии")])]), _vm._v(" "), _c('div', {
    staticClass: "patient-form"
  }, [_vm._l((_vm.allergy), function(record) {
    return _c('div', {
      staticClass: "patient-form-block"
    }, [_c('label', {
      attrs: {
        "for": "label-1"
      }
    }, [_vm._v(_vm._s(record.label) + ":")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (record.value),
        expression: "record.value"
      }],
      attrs: {
        "id": "label-1",
        "type": "text",
        "readonly": "readonly"
      },
      domProps: {
        "value": (record.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(record, "value", $event.target.value)
        }
      }
    })])
  }), _vm._v(" "), (!_vm.allergy.length) ? _c('div', {
    staticClass: "patient-form-block"
  }, [_vm._v("\n\t\t\tНет записей\n\t\t")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0599f6ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Widgets/Allergy.vue
// module id = 571
// module chunks = 0